const WMO_AR = { 0: 'سماء صافية', 1: 'صافٍ غالباً', 2: 'غائم جزئياً', 3: 'ملبّد بالغيوم', 45: 'ضباب', 48: 'ضباب متجمّد', 51: 'رذاذ خفيف', 53: 'رذاذ متوسط', 55: 'رذاذ كثيف', 56: 'رذاذ متجمّد خفيف', 57: 'رذاذ متجمّد كثيف', 61: 'مطر خفيف', 63: 'مطر متوسط', 65: 'مطر غزير', 66: 'مطر متجمّد خفيف', 67: 'مطر متجمّد غزير', 71: 'تساقط ثلوج خفيف', 73: 'تساقط ثلوج متوسط', 75: 'تساقط ثلوج كثيف', 77: 'حبيبات ثلجية', 80: 'زخات مطر خفيفة', 81: 'زخات مطر متوسطة', 82: 'زخات مطر عنيفة', 85: 'زخات ثلجية خفيفة', 86: 'زخات ثلجية كثيفة', 95: 'عاصفة رعدية', 96: 'عاصفة رعدية مع برَد خفيف', 99: 'عاصفة رعدية مع برَد كثيف' };
const condText = (language, item) => (language === 'ar' && WMO_AR[item.code] !== undefined ? WMO_AR[item.code] : item.desc);

export function WeatherWidget({ language, weather, weatherLoading, weatherError, fetchWeather }) {
  return (
    <section className="weather-section" data-testid="weather-section">
      <div className="container">
        <h2 className="section-title stats-title">
          {language === 'ar' ? 'طقس اسطنبول الحالي' : language === 'ru' ? 'Погода в Стамбуле' : language === 'tr' ? 'İstanbul Hava Durumu' : 'Istanbul Live Weather'}
          {weather && <span className="rates-live-dot"></span>}
        </h2>
        {weatherLoading && !weather && (
          <div className="widget-loading" data-testid="weather-loading">
            <div className="widget-spinner"></div>
            <span>{language === 'ar' ? 'جاري تحميل الطقس...' : language === 'ru' ? 'Загрузка погоды...' : language === 'tr' ? 'Hava durumu yükleniyor...' : 'Loading weather data...'}</span>
          </div>
        )}
        {weatherError && !weather && (
          <div className="widget-error" data-testid="weather-error">
            <span>{language === 'ar' ? 'تعذر تحميل الطقس' : language === 'ru' ? 'Не удалось загрузить погоду' : language === 'tr' ? 'Hava durumu yüklenemedi' : 'Could not load weather data'}</span>
            <button className="widget-retry-btn" data-testid="weather-retry" onClick={fetchWeather}>
              {language === 'ar' ? 'إعادة المحاولة' : language === 'ru' ? 'Повторить' : language === 'tr' ? 'Tekrar dene' : 'Retry'}
            </button>
          </div>
        )}
        {weather && (
          <>
            <div className="weather-widget">
              <div className="weather-current" data-testid="weather-current">
                <div className="weather-icon-large">{weather.current.icon}</div>
                <div className="weather-current-info">
                  <span className="weather-temp-large">{Math.round(weather.current.temp)}°C</span>
                  <span className="weather-desc">{condText(language, weather.current)}</span>
                  <div className="weather-details">
                    <span>{language === 'ar' ? 'يبدو كـ' : language === 'ru' ? 'Ощущается' : language === 'tr' ? 'Hissedilen' : 'Feels'} {Math.round(weather.current.feels_like)}°C</span>
                    <span>💧 {weather.current.humidity}%</span>
                    <span>💨 {weather.current.wind_speed} km/h</span>
                  </div>
                </div>
              </div>
              <div className="weather-forecast" data-testid="weather-forecast">
                {weather.forecast.map((day, i) => (
                  <div className="weather-day" key={day.date}>
                    <span className="weather-day-name">{i === 0 ? (language === 'ar' ? 'اليوم' : language === 'ru' ? 'Сегодня' : language === 'tr' ? 'Bugün' : 'Today') : new Date(day.date).toLocaleDateString(language === 'ar' ? 'ar' : language === 'ru' ? 'ru' : language === 'tr' ? 'tr' : 'en', { weekday: 'short' })}</span>
                    <span className="weather-day-icon">{day.icon}</span>
                    <span className="weather-day-temps">{Math.round(day.max)}° / {Math.round(day.min)}°</span>
                  </div>
                ))}
              </div>
            </div>
            <p className="rates-footer">
              <span className="rates-source">{language === 'ar' ? 'المصدر:' : language === 'ru' ? 'Источник:' : language === 'tr' ? 'Kaynak:' : 'Source:'} <a href="https://www.accuweather.com/en/tr/istanbul/318251/weather-forecast/318251" target="_blank" rel="noopener noreferrer">{language === 'ar' ? 'AccuWeather إسطنبول' : 'AccuWeather Istanbul'}</a></span>
              <span className="rates-updated">{language === 'ar' ? 'يتم التحديث كل 15 دقيقة' : language === 'ru' ? 'Обновляется каждые 15 минут' : language === 'tr' ? 'Her 15 dakikada güncellenir' : 'Updates every 15 minutes'}</span>
            </p>
          </>
        )}
      </div>
    </section>
  );
}
